/**
 * @namespace {BX.UI}
 */
export default class ButtonSize
{
	static EXTRA_LARGE = 'ui-btn-xl';
	static LARGE = 'ui-btn-lg';
	static MEDIUM = 'ui-btn-md';
	static SMALL = 'ui-btn-sm';
	static EXTRA_SMALL = 'ui-btn-xs';
	static EXTRA_EXTRA_SMALL = 'ui-btn-xss';
}
